import { Injectable } from '@angular/core';
import { Auth0Client } from '@auth0/auth0-spa-js';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Auth0ClientFactory {
  public create(): Auth0Client {
    return new Auth0Client({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      useRefreshTokens: true,
      cacheLocation: environment.auth0.cacheLocation
    });
  }
}
